import React, { useEffect, useState } from 'react'
import media from 'styled-media-query'
import styled from 'styled-components'
import axios from 'axios'
import Input from '../../atoms/Input/Input'
import Button from '../../atoms/Button/Button'
import LocationPin from '../../../images/interface/map-marker.svg'
import X from '../../../images/blackx.svg'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { graphql, useStaticQuery } from 'gatsby'
import useInsights from '../../../hooks/algolia/useInsights'
import { useRef } from 'react'
import useSegment from '../../../hooks/segment/useSegment'
import { createDataLayerIfNotExists } from '../../../utils/global/createDataLayerIfNotExists'
import { isNonEmptyString } from '../../../utils/checks'
import noop from '../../../utils/noop'

export default function Modal({
  breadcrumbs,
  busContact,
  dashboard,
  email,
  image,
  insuranceAccepted,
  listing_template,
  location,
  slug,
  title,
  toggle,
  trackingID,
  queryID,
  centerId,
  benefitsProvider,
  benefitsKey
}) {
  const { userID, recordAlgoliaConversion } = useInsights()
  const site = useStaticQuery(graphql`
    query MyQuerys {
      allLocation {
        edges {
          node {
            slug
          }
        }
      }
    }
  `)
  const availableSlug = site?.allLocation.edges.map((edge) => {
    return edge.node.slug
  })

  const filteredBreadCrumbs = breadcrumbs
    ?.map((loc) => ({
      title: loc
    }))
    ?.filter((loc) =>
      availableSlug.includes(loc?.title?.toLowerCase().replace(/\ /g, '-'))
    )
  const [state, setState] = useState({
    sent: false,
    form: {
      action: 'send',
      fullName: false, // Honey Pot
      centerTitle: title,
      centerEmail: email,
      bus_contact: busContact || '',
      dashboard: dashboard || '',
      slug: slug,
      email: '',
      message: '',
      name: ''
    }
  })
  const [emailValid, setEmailValid] = useState(false)
  const [error, setError] = useState({
    name: false,
    nameBlured: false,
    message: false,
    messageBlured: false,
    email: false,
    emailBlurred: false
  })
  const validateEmail = (mail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      setEmailValid(true)
    } else {
      setEmailValid(false)
    }
  }
  useEffect(() => {
    validateEmail(state.form?.email)
  }, [state.form?.email])
  const serialize = (source) => {
    var array = []

    for (var key in source) {
      array.push(
        encodeURIComponent(key) + '=' + encodeURIComponent(source[key])
      )
    }

    return array.join('&')
  }
  const ref = useRef()
  const segment = useSegment()
  const handleSubmit = (e) => {
    e.preventDefault()
    // Turn url params into object
    const urlParams = new URLSearchParams(window.location.search)
    const urlParamsObj = {}
    for (const [key, value] of urlParams) {
      urlParamsObj[key] = value
    }
    recordAlgoliaConversion({
      userID,
      event:
        trackingID == 'Center Feed Card' ? 'ListingInquiry' : 'ProfileInquiry',
      queryID: queryID || urlParamsObj.__queryID || '',
      objectID: slug
    })
    setState({ sent: true })
    // format Data

    if (
      benefitsProvider &&
      benefitsProvider.toLowerCase() === 'dazoscrm' &&
      isNonEmptyString(benefitsKey)
    ) {
      axios
        .post('/api/dazosCRM/createLead', {
          ...state.form,
          centerId,
          benefitsKey
        })
        .then((res) => {
          return res
        })
        .catch((e) => {
          console.error('error sending form', e)
        })
    }

    if (state.form.fullName == false && state.form.message.length < 10000) {
      // axios.post(`https://us-central1-rehabpath-e97f8.cloudfunctions.net/contact`, this.state.form).then(res => {
      axios
        .post(
          'https://us-central1-rehabpath-e97f8.cloudfunctions.net/newContact',
          serialize(state.form)
        )
        .then(async () => {
          axios
            .post('/api/sf-integration', serialize(state.form))
            .catch((e) => console.log(e))
          segment.profilePage.inquirySubmitted({
            slug: slug,
            verify_insurance: state.form.insurance || false
          })
          createDataLayerIfNotExists()
          // the below code pertains to Google Tag Manager and may have no context outside of this file; DO NOT DELETE.
          window.dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            center_slug: slug,
            form_type: 'treatment_inquiry',
            form_location: trackingID,
            event: 'inquiry_sent'
          })
          window.dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
              items: [
                {
                  item_name: title,
                  item_id: slug,
                  item_variant: listing_template,
                  item_category: 'Email Modal'
                }
              ]
            }
          })
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }

  const handleInput = (e) => {
    setState({
      ...state,
      form: {
        ...state.form,
        [e.target.name]:
          e.target.name === 'insurance'
            ? e.target.checked
            : e.target.name === 'phone'
            ? e.target.value
                .replace(' ', '')
                .replace(' ', '')
                .replace(' ', '')
                .trim()
            : e.target.value
      }
    })
  }
  const [nameError, setNameError] = useState()
  const [messageError, setMessageError] = useState()
  const [emailError, setEmailError] = useState()
  useEffect(() => {
    if (!state.form?.name && error.nameBlured) {
      setNameError(true)
    } else {
      setNameError(false)
    }
    if (!state.form?.message && error.messageBlured) {
      setMessageError(true)
    } else {
      setMessageError(false)
    }
    if ((!state?.form?.email || !emailValid) && error.emailBlurred) {
      setEmailError(true)
    } else {
      setEmailError(false)
    }
  }, [
    state.form?.name,
    state.form?.email,
    state.form?.message,
    error,
    emailValid
  ])
  return (
    <ModalStyle>
      <div className="window contact-form">
        {state.sent && (
          <div className="success">
            <img
              src={X}
              style={{
                position: 'absolute',
                right: '24px',
                top: '24px',
                cursor: 'pointer'
              }}
              className="desktop"
              onClick={() => {
                toggle()
              }}
            />
            <div style={{ padding: '0px 0px' }}>
              <p className="suc-header">Success!</p>
              <p className="suc-body">
                The team at {title} will be able to contact you directly for
                next steps.
              </p>
            </div>
            <Button
              onClick={() => {
                toggle()
              }}
              style={{
                height: '42px',
                width: '80px',
                marginTop: '12px',
                borderRadius: '6px',
                background: '#E55925'
              }}
            >
              OK
            </Button>
            <a
              className="search"
              href={
                breadcrumbs &&
                `/${filteredBreadCrumbs[filteredBreadCrumbs.length - 1]?.title
                  ?.toLowerCase()
                  .replaceAll(' ', '-')}`
              }
              onClick={() => {
                if (!breadcrumbs) {
                  toggle()
                }
              }}
            >
              Continue your search
            </a>
          </div>
        )}
        {!state.sent && (
          <div className="container">
            <div className="left-bar">
              <p className="title">Email {title}</p>
              <p className="location-title">
                <img
                  src={LocationPin}
                  className="pin"
                />{' '}
                {location}
              </p>
              <div className="center-image-contianer">
                <img
                  src={image.replace('upload/', 'upload/q_60,w_236,h_162/')}
                  className="center-image"
                />
              </div>
              <p className="info">
                {title}'s admissions team will receive your message directly and
                contact you shortly.
              </p>
            </div>
            <div
              className="form-area"
              style={{ position: 'relative' }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '35px',
                  right: '35px'
                }}
                className="cancel-container desktop"
              >
                <img
                  src={X}
                  className="cancel"
                  onClick={() => {
                    toggle()
                  }}
                />
              </div>
              <div className="mobile ">
                <div className="header-container">
                  <p className="header">Contact {title}</p>
                  <div className="cancel-container">
                    <img
                      src={X}
                      className="cancel"
                      onClick={() => {
                        toggle()
                      }}
                    />
                  </div>
                </div>
                <div className="tagline-container">
                  <div className="image-container">
                    <img
                      src={image.replace('upload/', 'upload/q_60,w_69,h_47/')}
                      style={{
                        height: '100%',
                        width: '100%',
                        maxWidth: '69px'
                      }}
                      loading="eager"
                    />
                  </div>
                  <p
                    className="footer-text"
                    style={{
                      fontSize: '14px'
                    }}
                  >
                    {title}’s admissions team will receive your message directly
                    and contact you shortly.
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit}>
                <div onBlurCapture={noop}>
                  <Input
                    onChange={handleInput}
                    className="email-us-modal__name"
                    isRequired
                    name="name"
                    placeholder="Your Name"
                    id="form-name"
                    onBlur={() => {
                      setError({
                        ...error,
                        nameBlured: true
                      })
                    }}
                    autoFocus
                  />
                  {nameError && (
                    <p
                      style={{
                        color: 'red',
                        marginTop: '-20px'
                      }}
                    >
                      Field Required
                    </p>
                  )}
                  <br />
                  <label htmlFor={name}>Phone</label>
                  <PhoneInput
                    country={'us'}
                    value={state.form?.['phone']}
                    onChange={(phone) => console.log(phone)}
                    inputProps={{
                      name: 'phone',
                      autoFocus: false,
                      onChange: handleInput
                    }}
                    enableSearch={true}
                    searchClass="search-class"
                    containerStyle={{ display: 'flex' }}
                    containerClass="email-us-modal__phone-number input-component"
                    // buttonClass='email-us-modal__phone-number input-component'
                    // containerStyle={{background: 'red'}}
                    inputClass="email-us-modal__phone-number input-component"
                    inputStyle={{ paddingLeft: '45px' }}
                    // inputStyle={{color: 'red'}}
                    placeholder="Your Phone Number (optional)"
                  />
                  {/* <Input
                    onChange={handleInput}
                    className="email-us-modal__phone-number"
                    name="phone"
                    placeholder="Your Phone Number (optional)"
                    formattedInput
                  /> */}
                  {/* <NumberFormat format="#### #### #### ####" className="email-us-modal__phone-number" /> */}
                  {
                    // Honey Pot
                  }
                  <input
                    type="hidden"
                    name="fullName"
                    onChange={handleInput}
                  />

                  <br />
                  <div className="reverse">
                    <div>
                      <Input
                        onChange={handleInput}
                        className="email-us-modal__message"
                        isRequired
                        onFocus={(e) => (e.target.placeholder = '')}
                        textArea
                        name="message"
                        placeholder={`I am interested in getting treatment at ${title}, my primary need is....`}
                        onBlur={() => {
                          setError({
                            ...error,
                            messageBlured: true
                          })
                        }}
                      />
                      {messageError && (
                        <p
                          style={{
                            color: 'red',
                            marginTop: '-19px',
                            marginBottom: '10px'
                          }}
                        >
                          Field Required
                        </p>
                      )}
                    </div>
                    <div>
                      <Input
                        onChange={handleInput}
                        className="email-us-modal__email"
                        isRequired
                        name="email"
                        placeholder="Your email address"
                        type="email"
                        onBlur={() => {
                          setError({
                            ...error,
                            emailBlurred: true
                          })
                        }}
                      />
                      {emailError && (
                        <p
                          style={{
                            color: 'red',
                            marginTop: '-19px',
                            marginBottom: '10px'
                          }}
                        >
                          {!emailValid ? 'Invalid email' : 'Field Required'}
                        </p>
                      )}
                    </div>
                  </div>
                  {insuranceAccepted === true && (
                    <div className="group">
                      <input
                        type={'checkbox'}
                        name="insurance"
                        onChange={handleInput}
                        style={{
                          height: '24px',
                          width: '24px',
                          border: '2px solid #DCE7E8',
                          borderRadius: '6px'
                        }}
                        // onChange={(e)=>{
                        //   if(e.target.checked === true){
                        //     set
                        //   }
                        //   console.log(e.target.checked)
                        // }}
                      />
                      <label className="insurance-label">
                        <span className="">Verify my insurance</span>
                      </label>
                    </div>
                  )}
                  <div className="prefered">
                    <div style={{ marginRight: '10px' }}>
                      <p className="text">Preferred Contact method</p>
                    </div>
                    <div className="radio-group">
                      <div
                        className="option"
                        style={{ marginRight: '24px' }}
                      >
                        <input
                          type={'radio'}
                          name="contact-method"
                          value={'phone'}
                          onChange={handleInput}
                          style={{
                            height: '24px',
                            width: '24px',
                            border: '2px solid #DCE7E8',
                            borderRadius: '6px'
                          }}
                        />
                        <label className="insurance-label">Phone</label>
                      </div>
                      <div className="option">
                        <input
                          type={'radio'}
                          name="contact-method"
                          value={'email'}
                          onChange={handleInput}
                          style={{
                            height: '24px',
                            width: '24px',
                            border: '2px solid #DCE7E8',
                            borderRadius: '6px'
                          }}
                        />
                        <label className="insurance-label">Email</label>
                      </div>
                    </div>
                  </div>
                  <Button
                    noTheme
                    type="submit"
                    fontSize={'17px'}
                    fluid
                    disabled={
                      !(
                        state.form.name?.length > 1 &&
                        state.form.message?.length > 1 &&
                        emailValid
                      )
                    }
                    // disabled={true}
                  >
                    Send
                  </Button>
                  {/* <div className="mobile">
                    <p className="footer-text">
                      {title}’s admissions team will receive your message
                      directly and contact you shortly.
                    </p>
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <div
        onClick={toggle}
        className="overlay"
      />
    </ModalStyle>
  )
}
const ModalStyle = styled.div`
.search{
  margin-top: 30px;
  text-decoration: none;
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 140%;
text-align: center;
color: #0977BB;
cursor: pointer;
${media.lessThan('medium')`
    margin-top: 17px;
    
  `}
}
.suc-header{
font-style: normal;
font-weight: 700;
font-size: 40px;
line-height: 51px;
text-align: center;
letter-spacing: -0.01em;
color: #383838;
}
.suc-body{
  text-align: center;
  ${media.greaterThan('medium')`
    max-width: 394px;
  `}

  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 25px;
  text-align: center;
  color: #383838;
}
  .success {
    background: white;
    position: relative;
    width: 722px;
    height 387px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    ${media.lessThan('medium')`
    height: 215px;
    margin: auto 0;
    width: 100vw;
    
  `}
  }
  .search-class{
    display: flex;
    input{
      height: 32px !important;
    }
  }
  .react-tel-input .country-list .search-emoji {
    font-size: 15px;
    padding-top:10px;
}
  .prefered {
    display: block;
    ${media.lessThan('medium')`
    display: flex;
    
  `};
  }
  .footer-text {
    margin: auto 0px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    color: #fff;
  }
  .tag-line {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
    width: 70%;
  }
  .image-container {
    height: 100%;
    margin-right: 10px;
    border-radius: 6px;
    min-width: 69px;
    height: 47px;
  }
  .tagline-container {
    margin-bottom: 16px;
    display: flex;
    padding: 7px 8px;
    width: 100%;
    
    background: #405c63;
    border-radius: 4px;
  }
  .cancel {
    height: 16px;
    width: 16px;
    cursor: pointer;
  }
  .cancel-continer {
    width: 20px;
    height: 100px;
    display: flex;
    align-items: center;
  }
  .header-container {
    margin-bottom: 19px;
    display: flex;
  }
  .header {
    flex: 1;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #4d657f;
  }
  .desktop {
    display: none;
    ${media.greaterThan('medium')`
    display: block;
    
  `};
  }
  .mobile {
    display: none;
    ${media.lessThan('medium')`
    display: block;
    
  `};
  }
  .reverse {
    display: flex;
    flex-direction: column;
    width: 100%;
    ${media.lessThan('medium')`
  flex-direction: column-reverse;
      
    `};
  }
  .option {
    display: flex;
    align-items: center;
  }
  .text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #383838;
    margin-bottom: 8px;
  }
  .radio-group {
    display: flex;
    margin-bottom: 24px;
    ${media.lessThan('medium')`
    
`}
  }
  .group {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  .insurance-label {
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: right;
    color: #383838;
    margin-left: 4px;
  }
  .info {
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 25px;
    /* or 147% */

    /* rp/Neutral/light 400 */

    color: #ffffff;
  }
  .center-image {
    height: 100%;
    border-radius: 6px;
    width: 100%;
  }
  .center-image-contianer {
    height: 162px;
    width: 100%;
    margin-bottom: 20px;
  }
  .title {
    margin-bottom: 2px;
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    color: white;
  }
  .location-title {
    margin-left: 0;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 21px;
    color: white;
    margin-bottom: 12px;
  }
  .pin {
    height: 16px;
    width: 16px;
    margin-right: 6.6px;
    margin-left: 0 !important;
  }
  .form-area {
    overflow-y: auto;
    padding: 32px;
    flex: 1;
    ${media.lessThan('medium')`
    overflow-x: hidden;
    padding: 24px;
    `}
  }
  .left-bar {
    height: 100%;
    width: 300px;
    background: #405c63;
    padding: 45px 32px;
    ${media.lessThan('medium')`
      display: none;
    `}
  }
  .container {
    border-radius: 8px;
    ${media.lessThan('medium')`
    border-radius: 0px;
    `}
    background: white;
    display: flex;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  z-index: 9999;
  svg {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 22px;
    cursor: pointer;
  }
  .window {
    .close-button {
    }
    z-index: 10000;
    width: 751px;
    height: 660px;
    max-height: 100vh;
    border-radius: 8px;
    position: fixed;
    top: calc(50% - 325px);
    right: calc(50% - 360px);
    ${media.lessThan('medium')`
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    top: 0;
    right: 0;
    `}
    .sub-header {
      font-weight: 800;
      color: #a7a7a7;
    }
    h4 {
      font-size: 35px;
      text-transform: uppercase;
      text-align: left;
    }
    button {
      width: 100%;
    }
    .input-component {
      width: 100%;
      margin-bottom: 24px;
      input {
        font-size: 16px;
        width: 258px;
        height: 42px;
        ${media.lessThan('medium')`
        height: 58px;
        width: 100%;

    `}
        border-radius: 8px;
        border-bottom: none;
        border: 1px solid #dce7e8;
        background: white;
        padding-left: 10px;
        color: #383838;
        ::placeholder {
          color: #8dafb4;
          opacity: 1; /* Firefox */
        }

        :-ms-input-placeholder {
          color: #8dafb4;
        }

        ::-ms-input-placeholder {
          color: #8dafb4;
        }
      }
      textarea {
        width: 100%;
        border-radius: 8px;
        border-bottom: none;
        border: 1px solid #dce7e8;
        background: white;
        padding-left: 10px;
        color: #383838;
        max-width: none;
        height: 150px;
        ${media.lessThan('medium')`
        height: 100px;
        `}
        padding-top: 10px;
        ::placeholder {
          color: #8dafb4;
          opacity: 1; /* Firefox */
        }

        :-ms-input-placeholder {
          color: #8dafb4;
        }

        ::-ms-input-placeholder {
          color: #8dafb4;
        }
      }
    }
  }
  .overlay {
    z-index: 9999;
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    width: 100vw;
    height: 100vh;
    right: 0;
    top: 0;
  }
`
